import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <div className="font-heading text-7xl md:text-9xl font-bold text-primary-200 mb-4">404</div>
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
            这个页面去韩国旅行了~
          </h1>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-md mx-auto">
            抱歉，你访问的页面暂时迷路了。不如回到首页，重新规划你的韩国之旅？
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}